import { render, staticRenderFns } from "./ModalityInfosForm.vue?vue&type=template&id=8bd91c32&scoped=true"
import script from "./ModalityInfosForm.vue?vue&type=script&lang=js"
export * from "./ModalityInfosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd91c32",
  null
  
)

export default component.exports